export class Slider {

  private readonly sliders: NodeListOf<Element>;

  constructor() {
    this.sliders = document.querySelectorAll("[data-slider]");

    this.init()
  }

  private init() {
    this.sliders.forEach((slider) => {
      const images = slider.querySelectorAll<HTMLElement>("[data-slider-item]");
      let currentIndex = -1;

      function next() {
        currentIndex = (currentIndex + 1) % images.length;

        images.forEach((value, key) => {
          value.classList[key === currentIndex ? "add" : "remove"]("c-slider__item--active")
        });
      }

      setInterval(next, 4000);
      next()
    });
  }
}

document.addEventListener("DOMContentLoaded" , () => {
  new Slider()
});
